import {Text} from '../../../../../../component/text/text';

import * as styles from './export-template-preview-table.module.scss';

export function ExportTemplatePreviewLabel(): JSX.Element {
    return (
        <div className={styles.ExportTemplatePreviewTable_label}>
            <Text lighter stringKey="REVIEWS__EXPORT_CONSTRUCTOR__PREVIEW_LABEL" />
            <Text secondary stringKey="REVIEWS__EXPORT_CONSTRUCTOR__PREVIEW_HINT" />
        </div>
    );
}
